import type { CertGenParams } from '@yandex-int/k-common';

export const GLInfSpring2022 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
}: CertGenParams) => {
    return `
        <!doctype html>
        <html lang="ru" xmlns="http://www.w3.org/1999/html">
        <head>
            <meta charset="utf-8"/>
            <meta name="description" content=""/>
            <meta name="keywords" content=""/>
            <meta name="viewport" content="width=device-width, maximum-scale=1.0, initial-scale=1.0"/>
            <style type="text/css">
                /*
                //-----------------------------------------
                // Fonts
                //-----------------------------------------
                */

                @font-face {
                    font-family: 'YS Text';
                    src: url("https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2") format("woff2"),
                    url("https://yastatic.net/s3/home/fonts/ys/1/text-light.woff") format("woff");
                    font-weight: 300;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2") format("woff2"),
                    url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff") format("woff");
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2") format("woff2"),
                    url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff") format("woff");
                    font-weight: 500;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2") format("woff2"),
                    url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff") format("woff");
                    font-weight: 700;
                    font-style: normal;
                }

                /*
                //-----------------------------------------
                // Print specifics
                //-----------------------------------------
                */

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                }

                @page {
                    margin: 0;
                }

                /*
                //-----------------------------------------
                // Scaffolding
                //-----------------------------------------
                */

                html, body {
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                }

                body {
                    font: 400 12pt/1.4 'YS Text';
                    color: #000;
                    min-height: 100%;
                    height: auto !important;
                    height: 100%;
                    background: #FFFFFF;
                    -webkit-text-size-adjust: 100%;
                }

                * {
                    box-sizing: border-box;
                }

                /*
                //-----------------------------------------
                // Certificate
                //-----------------------------------------
                */

                .page {
                    position: relative;
                    width: 210mm;
                    height: 297mm;
                    overflow: hidden;
                    page-break-after: always;
                    break-after: page;
                    padding: calc(32 * 210mm / 638) calc(38 * 297mm / 895);

                    background: no-repeat bottom/contain url("https://e7n.s3.yandex.net/static/cert-inf-2022-spring-olymp/background.png");
                }


                .page__certificate {
                    position: relative;
                }

                .certificate__content {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                }

                .content__left, .content__right {
                    display: flex;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    align-items: flex-start;
                }

                .content__left {
                    max-width: calc(333 * 210mm / 638);

                    margin-right: calc(48 * 210mm / 638);
                }

                .content__title {
                    font-size: 32pt;
                    line-height: 34pt;
                    letter-spacing: 0;
                    text-align: left;

                    font-weight: 500;

                    height: calc(76 * 297mm / 895);
                }

                .content__personal-info {
                    margin-top: calc(32 * 297mm / 895);

                    letter-spacing: 0;
                    text-align: left;
                }

                .name {
                    font-size: 21pt;
                    line-height: 24pt;

                    height: calc(96 * 297mm / 895);;
                }

                .school {
                    font-size: 9pt;
                    line-height: 12pt;
                    text-align: left;

                    height: calc(32 * 297mm / 895);;

                    margin-top: calc(16 * 297mm / 895);
                }

                .content__description {
                    font-size: 11pt;
                    line-height: 17pt;
                    letter-spacing: 0;
                    text-align: left;

                    margin-top: calc(32 * 297mm / 895);
                }

                .content__signature {
                    margin-top: auto;
                }

                .content__logo {
                    height: calc(23 * 297mm / 895);
                    width: calc(188 * 210mm / 638);

                    margin-top: calc(6 * 297mm / 895);
                }

                .logo {
                    width: 100%;
                    height: 100%;
                }

                .signature__name {
                    font-size: 10pt;
                    line-height: 11pt;
                    letter-spacing: 0;
                    text-align: left;
                }

                .signature__position {
                    font-size: 8pt;
                    line-height: 11pt;
                    letter-spacing: 0;
                    text-align: left;

                    margin-top: calc(8 * 297mm / 895);
                }

            </style>
        </head>
        <body>

        <!-- PAGE 1 - CERTIFICATE -->
        <div class="page">
            <div class="certificate page__certificate">
                <div class="content certificate__content">
                    <div class="content__left">
                        <div class="content__title">
                            Благодарственное
                            <br/>
                            письмо
                        </div>
                        <div class="content__personal-info">
                            <div class="name">
                                ${lastName}<br>
                                ${firstName}<br>
                                ${middleName}
                            </div>
                            <div class="school">
                                ${schoolName}
                            </div>
                        </div>
                        <div class="content__description">
                            Уважаемый учитель!<br>
                            Благодарим Вас за вклад в развитие олимпиадного движения и активное участие<br>
                            Ваших учеников в олимпиаде по информатике от Яндекс Учебника для 6–11 классов.
                        </div>
                    </div>
                    <div class="content__right">
                        <div class="content__logo">
                            <img class="logo"
                             src="https://e7n.s3.yandex.net/static/cert-inf-2022-spring-olymp/logo.svg"
                             alt="Лого Яндекс">
                        </div>
                        <div class="signature content__signature">
                            <img class="signature__img"
                                 src="https://e7n.s3.yandex.net/static/cert-inf-2022-spring-olymp/signature.svg"
                                 alt="Подпись A. М. Москвичев">
                            <div class="signature__name">
                                А. М. Москвичев
                            </div>
                            <div class="signature__position">
                                Руководитель сервиса<br>
                                Яндекс Учебник
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </body>
        </html>
    `;
};
